
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/birthday-bot/preview",
      function () {
        return require("private-next-pages/birthday-bot/preview.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/birthday-bot/preview"])
      });
    }
  